import { render, staticRenderFns } from "./ContabilizarIcon.vue?vue&type=template&id=508d54c2&scoped=true"
var script = {}
import style0 from "./ContabilizarIcon.vue?vue&type=style&index=0&id=508d54c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508d54c2",
  null
  
)

export default component.exports